<template>
	<div class="yqyy">
		<div class="cardK">
			<div class="card">
				<div class="title">
					物业管理费（2025年）
				</div>
				<div class="content wysf">
					<div class="l">
						<div class="item">
							<div>实收金额</div>
							<span>¥463,436.13</span>
						</div>
						<div class="item">
							<div>应收金额</div>
							<span>¥474,847.97</span>
						</div>
						<!-- <div class="item">
							<div>预缴金额</div>
							<span>￥1,558.2</span>
						</div> -->
					</div>
					<div class="r">
						<div class="rInner" id="chart1" ref="chart1"></div>
						<div class="showTitle">
							<span>97.59%</span>
							<p>收缴率</p>
						</div>
					</div>
				</div>
			</div>
			<div class="card">
				<div class="title">
					收缴分析
				</div>
				<div class="tabs">
					<div :class="{on:tabIndex == 0}" @click="tabIndex = 0">本季</div>
					<div :class="{on:tabIndex == 1}" @click="tabIndex = 1">年度</div>
				</div>
				<div class="content sjfx">
					<div class="info">
						<div class="itemB">
							<div class="">
								<span class="label">{{data[tabIndex].label3}}</span>
								<div class="progress">
									<div class="progressInner" :style="{width: data[tabIndex].value3 + '%'}"></div>
									<span>{{Number(data[tabIndex].value3).toFixed(2) + '%'}}</span>
								</div>
							</div>
							<div class="">
								<span class="label">{{data[tabIndex].label4}}</span>
								<div class="progress">
									<div class="progressInner" :style="{width: data[tabIndex].value4 + '%'}"></div>
									<span>{{Number(data[tabIndex].value4).toFixed(2) + '%'}}</span>
								</div>
							</div>
							<span>逾期户数：3</span>
						</div>
					</div>
				</div>
				<div class="content sbxj" style="margin-top: 0;">
					<div class="viewList" ref="viewList">
						<div class="viewListTh">
							<div class="viewListTd">逾期单元</div>
							<div class="viewListTd">逾期时间</div>
							<div class="viewListTd">逾期金额</div>
						</div>
						<div class="viewListScroll" ref="viewListScroll3" @mousemove="isIn3 = true"
							@mouseleave="isIn3 = false" :style="{transform: 'translateY(-' + moveNum3 + 'px)'}">
							<div class="viewListTr" v-for="(item,index) in overdueList" :key="index">
								<div class="viewListTd">{{item.name}}</div>
								<div class="viewListTd">{{item.value}}</div>
								<div class="viewListTd">{{item.price}}元</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="content sjfx">

					<div class="bl">
						<img src="@/assets/yqyy/sjfx.png" alt="" />
						<div class="blInner">
							<img src="@/assets/yqyy/bl.png" class="blImg" alt="" />
							<div class="text">
								<span>{{data[tabIndex].num}}%</span>
								<p>{{data[tabIndex].title}}</p>
							</div>
						</div>
					</div>
					<div class="info">
						<div class="item">
							<span>{{data[tabIndex].label1}}</span>
							<p>{{data[tabIndex].value1}}</p>
						</div>
						<div class="item">
							<span>{{data[tabIndex].label2}}</span>
							<p>{{data[tabIndex].value2}}</p>
						</div>
						<div class="itemB">
							<div class="">
								<span class="label">{{data[tabIndex].label3}}</span>
								<div class="progress">
									<div class="progressInner" :style="{width: data[tabIndex].value3 + '%'}"></div>
									<span>{{Number(data[tabIndex].value3).toFixed(2) + '%'}}</span>
								</div>
							</div>
							<div class="">
								<span class="label">{{data[tabIndex].label4}}</span>
								<div class="progress">
									<div class="progressInner" :style="{width: data[tabIndex].value4 + '%'}"></div>
									<span>{{Number(data[tabIndex].value4).toFixed(2) + '%'}}</span>
								</div>
							</div>
						</div>
					</div>

				</div> -->

			</div>
			<div class="card">
				<div class="title">
					停车收费
				</div>
				<div class="content wysf">
					<div class="l">
						<div class="content sjfx" style="padding: 0;max-height: 55px;margin-bottom: 24px;">
							<div class="info" style="padding: 0;max-height: 55px;">
								<div class="itemB">
									<div class="">
										<span class="label">收缴率</span>
										<div class="progress">
											<div class="progressInner" :style="{width: '95%'}"></div>
											<span>95%</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="item">
							<div>月租实收金额</div>
							<span>¥19,000</span>
						</div>
						<div class="item">
							<div>月租应收金额</div>
							<span>¥20,000</span>
						</div>
					</div>
					<div class="l">
						<div class="item">
							<div>临停当日金额</div>
							<span>¥800</span>
						</div>
						<div class="item">
							<div>临停当月金额</div>
							<span>¥24,000</span>
						</div>
						<div class="item">
							<div>临停当年金额</div>
							<span>¥300,000</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="cardK">
			<div class="card card2">
				<div class="title">
					园区管理任务
				</div>
				<div class="content sbxj">
					<div class="viewList" ref="viewList">
						<div class="viewListTh">
							<div class="viewListTd">任务类型</div>
							<div class="viewListTd">任务名称</div>
							<div class="viewListTd">任务状态</div>
						</div>
						<div class="viewListScroll" ref="viewListScroll" @mousemove="isIn = true"
							@mouseleave="isIn = false" :style="{transform: 'translateY(-' + moveNum + 'px)'}">
							<div class="viewListTr" v-for="(item,index) in viewList" :key="index">
								<div class="viewListTd clamp_1">{{item.taskName}}</div>
								<div class="viewListTd clamp_1">{{item.taskNo}}</div>
								<div class="viewListTd clamp_1">{{item.taskStatus}}</div>
							</div>
							<div class="viewListTr" v-for="(item,index) in viewList" :key="'i'+index">
								<div class="viewListTd clamp_1">{{item.taskName}}</div>
								<div class="viewListTd clamp_1">{{item.taskNo}}</div>
								<div class="viewListTd clamp_1">{{item.taskStatus}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card">
				<div class="title">
					电梯数量
				</div>
				<div class="content dtsl">
					<div class="item">
						<img src="@/assets/yqyy/lm.png" alt="" />
						<span>在管设备</span>
						<p>54</p>
						<span>使用中</span>
						<p>48</p>
					</div>
					<div class="item">
						<img src="@/assets/yqyy/whl.png" alt="" />
						<span>设备完好率</span>
						<div>100.00%</div>
					</div>

				</div>
			</div>
		</div>
		<div class="cardK">
			<div class="card" style="flex: 2;">
				<div class="titleK">
					<div class="title">
						能源及其他收费
					</div>
					<span>周期（月）</span>
				</div>
				<div class="content wysf">
					<div class="l">
						<img src="@/assets/yqyy/shui.png" alt="" srcset="" />
						<div class="item">
							<div>水费实收金额</div>
							<span>¥24,163.53</span>
						</div>
						<div class="item">
							<div>水费应收金额</div>
							<span>¥25,167.22</span>
						</div>
						<!-- <div class="item">
							<div>预缴金额</div>
							<span>￥1,558.2</span>
						</div> -->
					</div>
					<div class="r">
						<div class="rInner" id="chart1" ref="chart3"></div>
						<div class="showTitle">
							<span>96.01%</span>
							<p>收缴率</p>
						</div>
					</div>
				</div>
				<div class="content wysf">
					<div class="l">
						<img src="@/assets/yqyy/dian.png" alt="" srcset="" />
						<div class="item">
							<div>电费实收金额</div>
							<span>¥129,183.84</span>
						</div>
						<div class="item">
							<div>电费应收金额</div>
							<span>¥133,179.22</span>
						</div>
						<!-- <div class="item">
							<div>预缴金额</div>
							<span>￥1,558.2</span>
						</div> -->
					</div>
					<div class="r">
						<div class="rInner" id="chart1" ref="chart4"></div>
						<div class="showTitle">
							<span>97.00%</span>
							<p>收缴率</p>
						</div>
					</div>
				</div>
				<div class="content wysf">
					<div class="l">
						<img src="@/assets/yqyy/qita.png" alt="" srcset="" />
						<div class="item">
							<div>其他实收金额</div>
							<span>¥28,679.33</span>
						</div>
						<div class="item">
							<div>其他应收金额</div>
							<span>¥29,243.28</span>
						</div>
						<!-- <div class="item">
							<div>预缴金额</div>
							<span>￥1,558.2</span>
						</div> -->
					</div>
					<div class="r">
						<div class="rInner" id="chart1" ref="chart5"></div>
						<div class="showTitle">
							<span>98.07%</span>
							<p>收缴率</p>
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="card">
				<div class="title">
					光伏数量
				</div>
				<div class="content chart4">
					<div class="info">
						<div class="legend" style="padding: 40px 0;">
							<div class="legendItem" v-for="(item,index) in chart4Data.series[0].data" :key="index">
								<i :style="{background: item.itemStyle.color}"></i>
								<div class="r">
									<span>{{item.name}}</span>
									<p>{{item.value}}%</p>
								</div>
							</div>
						</div>
					</div>
					<div class="chart chart4K">
						<div class="content" ref="chart4" id="chart4"></div>
						<div class="inner">
							<span>总数</span>
							<p>19</p>
						</div>
					</div>
				</div>
			</div> -->
			<div class="card">
				<div class="title">
					班车运营情况
				</div>
				<div class="content sbxj">
					<div class="viewList">
						<div class="viewListTh viewListTh2">
							<div class="viewListTd">车牌号</div>
							<div class="viewListTd">班次</div>
							<div class="viewListTd">发车时间</div>
							<div class="viewListTd">发车日期</div>
						</div>
						<div class="viewListScroll viewListScroll2" ref="viewListScroll2" @mousemove="isIn2 = true"
							@mouseleave="isIn2 = false" :style="{transform: 'translateY(-' + moveNum2 + 'px)'}">
							<div class="viewListTr" v-for="(item,index) in busList" :key="index">
								<div class="viewListTd">{{item.plateNumber}}</div>
								<div class="viewListTd">{{item.busName}}</div>
								<div class="viewListTd">{{item.busTime}}</div>
								<div class="viewListTd">{{item.busDate}}</div>
							</div>
							<div class="viewListTr" v-for="(item,index) in busList" :key="'i'+index">
								<div class="viewListTd">{{item.plateNumber}}</div>
								<div class="viewListTd">{{item.busName}}</div>
								<div class="viewListTd">{{item.busTime}}</div>
								<div class="viewListTd">{{item.busDate}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		chart1,
		chart2,
		chart3,
		chart4,
	} from '../common/yqyyOptions.js';
	import * as echarts from 'echarts';


	export default {
		data() {
			return {
				tabIndex: 1,
				moveNum: 0,
				moveNum2: 0,
				moveNum3: 0,
				isIn: false,
				isIn2: false,
				isIn3: false,
				data: [{
					num: 2.83,
					title: '本季收缴率',
					value1: '¥13,436.13',
					label1: '本季实收金额',
					value2: '¥423,112.25',
					label2: '本季应收金额',
					value3: 96.5,
					label3: '本季目标收缴率',
					value4: 99,
					label4: '本季目标收缴完成率',
				}, {
					num: 5.57,
					title: '年度收缴率',
					value1: '¥113,273.64',
					label1: '年度实收金额',
					value2: '¥2322,724.02',
					label2: '年度应收金额',
					value3: 98.2,
					label3: '年度目标收缴率',
					value4: 99.96,
					label4: '年度目标收缴完成率',
				}],
				overdueList: [{
					name: '1#3F',
					value: '3天',
					price: '3,000'
				},{
					name: '7#4F',
					value: '7天',
					price: '9,300'
				},{
					name: '15#2F',
					value: '1天',
					price: '2,700'
				}],
				chart1: null,
				// chart1Options: chart1,
				chart2: null,
				// chart2Options: chart2,
				chart3: null,
				// chart3Options: chart3,
				chart4: null,
				chart4Data: chart4,
				// chart5: null,
				// chart6: null,
				// chart7: null,
				viewList: [],
				busList: []
			}
		},
		created() {
			this.$nextTick(_ => {
				this.setChart();
				this.tabIndex = 0
				this.moveList();
			})
			let _self = this;
			window.addEventListener('resize', function() {
				clearTimeout(_self.timer)
				_self.timer = setTimeout(_ => {
					_self.resize()
				}, 1000)
			})
		},
		methods: {
			moveList() {
				let viewListScroll = this.$refs.viewListScroll;
				let viewListScroll2 = this.$refs.viewListScroll2;
				// let viewListScroll3 = this.$refs.viewListScroll3;
				if (this.moveNum > viewListScroll.offsetHeight / 2) {
					this.moveNum = 0
				}
				if (this.moveNum2 > viewListScroll2.offsetHeight / 2) {
					this.moveNum2 = 0
				}
				// if (this.moveNum3 > viewListScroll3.offsetHeight / 2) {
				// 	this.moveNum3 = 0
				// }
				if (!this.isIn)
					this.moveNum++;
				if (!this.isIn2)
					this.moveNum2++;
				// if (!this.isIn3)
				// 	this.moveNum3++;
				setTimeout(_ => {
					this.moveList();
				}, 30)
			},
			resize() {
				this.chart1.resize();
				// this.chart2.resize();
				this.chart3.resize();
				this.chart4.resize();
				// this.chart5.resize();
				// this.chart6.resize();
				// this.chart7.resize();
			},
			setChart() {
				this.chart1 = echarts.init(this.$refs.chart1, null, {devicePixelRatio: 2.5});
				this.chart1.setOption(chart1);

				// this.chart2 = echarts.init(this.$refs.chart2);
				// this.chart2.setOption(chart2);

				this.chart3 = echarts.init(this.$refs.chart3, null, {devicePixelRatio: 2.5});
				this.chart3.setOption(chart1);

				this.chart4 = echarts.init(this.$refs.chart4, null, {devicePixelRatio: 2.5});
				this.chart4.setOption(chart1);

				this.chart5 = echarts.init(this.$refs.chart5, null, {devicePixelRatio: 2.5});
				this.chart5.setOption(chart1);

				// 			this.chart6 = echarts.init(this.$refs.chart6);
				// 			this.chart6.setOption(chart6);

				// 			this.chart7 = echarts.init(this.$refs.chart7);
				// 			this.chart7.setOption(chart7);
				// let baseUrl = 'https://37338ro077.picp.vip/prod-api'
				this.$axios.get(this.$baseUrl + '/system/notToken/getIntraDayTaskList?pageSize=30').then(res => {
					if (res.status == 200 && res.data.code == 200) {
						this.viewList = res.data.data;
					}
				})
				this.$axios.get(this.$baseUrl + '/applet/busHistory/list?pageSize=30').then(res => {
					if (res.status == 200 && res.data.code == 200) {
						this.busList = res.data.rows;
					}
				})


			}
		}
	}
</script>

<style lang="scss" scoped>
	$main-color: #3ED4EB;
	$main2-color: #2b9ae4;
	$success: #ABFF9B;
	$danger: #BD1B3C;
	$blue: #2B9AE4;

	div {
		box-sizing: border-box;
	}

	.yqyy {
		flex: 1;
		padding: 20px 26px 0;
		overflow: hidden;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: stretch;

		.cardK {
			width: 33%;
			max-width: 33%;
			padding: 0 10px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.card {
				width: 100%;
				flex: 1;
				position: relative;

				&.card2 {
					flex: 2;
				}

				overflow: hidden;
				// background: linear-gradient(to right, #16213A 0%, #081E2F 50%, #16213A 100%);
				padding: 20px 18px;
				margin-bottom: 15px;
				display: flex;
				flex-direction: column;
				transition: all .2s;

				&:last-child {
					margin-bottom: 0;
				}
				.titleK{
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					align-items: center;
					span{
						font-size: 18px;
						color: $blue;
					}
				}
				.title {
					&:before {
						content: '';
						display: flex;
						width: 14px;
						height: 14px;
						border: 2px solid #57C9DE;
						background: #0667D4;
						margin-right: 12px;
					}

					display: flex;
					font-size: 18px;
					color: #FFF;
					flex-direction: row;
					justify-content: flex-start;
					align-items: center;
					font-weight: 500;
					user-select: none;
					line-height: 20px;
				}

				.content {
					width: 100%;
					flex: 1;

					.chart {
						height: 100%;
					}

					&.wysf {
						display: flex;
						flex-direction: row;
						justify-content: space-between;
						align-items: stretch;
						// padding-top: 20px;

						.l {
							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: center;
							width: 55%;
							padding-left: 30px;
							padding-top: 10px;
							margin: 0 10px;
							position: relative;
							img{
								width: 40px;
								height: 40px;
								position: absolute;
								left: -20px;
								top: 30px;
							}
							.item {
								width: 100%;
								height: 55px;
								position: relative;
								display: flex;
								flex-direction: row;
								justify-content: space-between;
								align-items: center;
								margin: 14px 0;
								background: linear-gradient(to right, rgba(15, 38, 60, 0) 0%, rgba(15, 38, 60, 1) 70%, rgba(15, 38, 60, 0) 100%);

								&:hover {
									background: linear-gradient(to right, rgba(26, 69, 109, 0) 0%, rgba(26, 69, 109, 1.0) 70%, rgba(26, 69, 109, 0) 100%);
								}

								&:before {
									content: '';
									display: flex;
									position: absolute;
									top: 0;
									left: 0;
									width: 100%;
									height: 2px;
									background: linear-gradient(to right, #192843 0%, #2e5881 70%, #192843 100%);
								}

								&::after {
									content: '';
									display: flex;
									position: absolute;
									bottom: 0;
									left: 0;
									width: 100%;
									height: 2px;
									background: linear-gradient(to right, #192843 0%, #2e5881 70%, #192843 100%);
								}

								div {
									font-size: 18px;
									color: $main2-color;
									white-space: nowrap;
									padding-right: 30px;
								}

								span {
									flex: 1;
									font-size: 22px;
									font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
								}
							}
						}

						.r {
							width: 45%;
							position: relative;
							display: flex;
							justify-content: center;
							align-items: center;

							.showTitle {
								position: absolute;
								display: flex;
								flex-direction: column;
								justify-content: center;
								align-items: center;
								padding-top: 46px;

								span {
									font-size: 25px;
								}

								p {
									font-size: 20px;
									color: $main2-color;
									margin-top: 20px;
								}
							}

							.rInner {
								width: 100%;
								height: 100%;
							}
						}
					}

					&.sjfx {
						display: flex;
						flex-direction: row;
						justify-content: space-between;
						align-items: stretch;
						flex: 1;

						.bl {
							width: 30%;
							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: center;
							position: relative;

							>img {
								width: 100%;
							}

							.blInner {
								width: 136px;
								height: 136px;
								border-radius: 50%;
								border: 1px solid $main2-color;
								overflow: hidden;
								position: absolute;
								display: flex;
								justify-content: center;
								align-items: center;

								@keyframes blMove {
									0% {
										transform: translateX(0);
									}

									100% {
										transform: translateX(calc(100% - 136px));
									}
								}

								.blImg {
									position: absolute;
									bottom: -40px;
									right: 0;
									height: 120px;
									animation: blMove 2s infinite linear;
								}

								.text {
									z-index: 2;
									text-align: center;

									span {
										font-size: 30px;

									}

									p {
										font-size: 15px;
									}
								}
							}
						}

						.info {
							flex: 1;
							padding: 20px 30px;
							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: flex-start;

							.item {
								width: 100%;
								margin-bottom: 4px;

								span {
									font-size: 15px;
									color: $main-color;
								}

								p {
									font-size: 30px;
									line-height: 40px;
								}
							}

							.itemB {
								width: 100%;
								display: flex;
								flex-direction: row;
								justify-content: space-between;
								align-items: flex-end;

								.label {

									font-size: 15px;
									color: $main-color;
								}

								&>div {
									flex: 1;
								}
								&>span{
									font-size: 13px;
									color: $main-color;
								}

								.progress {
									width: 80%;
									height: 20px;
									background: #233147;
									margin-top: 6px;
									position: relative;
									display: flex;
									align-items: center;

									.progressInner {
										width: 0;
										height: 100%;
										background: linear-gradient(to right, #0d71d7 0%, #61e6fd 100%);
										transition: all 1s;
									}

									span {
										position: absolute;
										left: 30%;
										line-height: 20px;
										font-size: 15px;
										padding-top: 2px;
									}
								}
							}
						}

					}

					&.sbxj {
						margin-top: 20px;
						max-height: 100%;
						position: relative;
						padding-top: 36px;

						.viewList {
							flex: 1;
							max-height: 100%;
							// padding: 0 8px 8px;
							overflow: hidden;
						}

						.viewListTh {
							display: flex;
							flex-direction: row;
							justify-content: space-between;
							align-items: center;
							width: 100%;
							height: 36px;
							background: #113F73;
							font-size: 14px;
							z-index: 2;
							position: absolute;
							top: 0;
							left: 0;

							.viewListTd {
								flex: 2;
								padding: 0 10px;
								color: #07DBFF;
								white-space: nowrap;
								display: flex;
							}

							.viewListTd:last-child {
								flex: 1;
								justify-content: center;
								align-items: center;
							}
						}

						.viewListTh2 {
							.viewListTd:last-child {
								flex: 2;
								justify-content: flex-start;
								align-items: flex-start;
							}
						}


						.viewListScroll {
							max-height: 100%;
							overflow: hidden;
							z-index: 1;

							.viewListTr {
								display: flex;
								border: 1px solid transparent;
								border-bottom: 1px solid #09718F;
								flex-direction: row;
								justify-content: space-between;
								align-items: center;
								height: 40px;
								position: relative;
								font-size: 14px;

								.viewListTd {
									padding: 0 10px;
									color: #CCC;
									flex: 2;
									display: flex;
									user-select: all;
								}

								.viewListTd:first-child {
									color: #FFF;
								}

								.viewListTd:last-child {
									flex: 1;
									justify-content: center;
									align-items: center;
								}


								&:hover {
									border: 1px solid #07DBFF;
									box-shadow: 0 0 10px 0 #07DBFF inset;
								}

								&:hover::after {
									content: '';
									display: block;
									border-top: 6px solid transparent;
									border-right: 6px solid #07DBFF;
									border-bottom: 6px solid transparent;
									border-left: 6px solid transparent;
									position: absolute;
									right: 8px;
								}
							}

							&.viewListScroll2 {
								.viewListTd:last-child {
									flex: 2;
									justify-content: flex-start;
									align-items: flex-start;
									white-space: nowrap;
								}
							}




							.viewListTitle {
								font-size: 14px;
								color: #FFF;
								display: flex;
								flex-direction: column;
								justify-content: center;
								align-items: center;
								height: 36px;
								min-height: 36px;
								letter-spacing: 3px;
								background: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 20%, #043D85 36%, #043D85 64%, rgba(0, 0, 0, 0) 80%, rgba(0, 0, 0, 0) 100%);
							}

							.viewListTitle::after {
								content: '';
								display: flex;
								width: 70%;
								height: 2px;
								background: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 20%, #31b7ff 30%, #FFF 50%, #31b7ff 70%, rgba(0, 0, 0, 0) 80%, rgba(0, 0, 0, 0) 100%);
							}
						}
					}

					&.dtsl {
						display: flex;
						flex-direction: row;
						justify-content: space-between;
						align-items: stretch;

						.item {
							flex: 1;
							margin: 20px 10px 0;
							background: #1a2b45;
							padding: 20px 30px;
							position: relative;
							display: flex;
							flex-direction: column;

							img {
								position: absolute;
								right: 30px;
								top: 20px;
								height: 30px;
							}

							span {
								font-size: 20px;
								color: $main-color;
							}

							p {
								font-size: 60px;
								line-height: 80px;
							}

							div {
								flex: 1;
								display: flex;
								align-items: center;
								font-size: 45px;
								line-height: 60px;
							}
						}
					}

					&.chart3 {
						position: relative;
						display: flex;
						justify-content: center;
						align-items: center;

						.chart {
							width: 100%;
							height: 100%;
						}

						.inner {
							position: absolute;
							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: center;

							span {
								font-size: 14px;
							}

							p {
								font-size: 22px;
								line-height: 22px;
							}
						}
					}

					&.chart4 {
						display: flex;
						flex-direction: row;
						justify-content: space-between;
						align-items: stretch;

						.info {
							width: 45%;
							min-width: 45%;
							height: 100%;

							.legend {
								height: 100%;
								display: flex;
								flex-direction: row;
								justify-content: center;
								align-items: center;
								flex-wrap: wrap;

								// 
								.legendItem {
									width: 50%;
									display: flex;
									flex-direction: row;
									justify-content: flex-start;
									align-items: flex-start;
									margin-bottom: 4%;

									&.legendItem2 {
										width: 25%;
									}

									i {
										display: flex;
										width: 12px;
										min-width: 12px;
										height: 12px;
										border-radius: 50%;
										margin: 5px 6px 0 0;
									}

									div {
										span {
											font-size: 14px;
											color: $main-color;
											line-height: 20px;
											white-space: nowrap;
										}

										p {
											font-size: 22px;
											color: #FFF;
											line-height: 30px;
											white-space: nowrap;
										}
									}
								}
							}
						}

						.chart {
							width: 60%;
							position: absolute !important;
							height: 100%;
							top: 0;
							right: 0;

							&.chart4K {
								display: flex;
								justify-content: center;
								align-items: center;

								.content {
									height: 100%;
								}
							}

							.inner {
								position: absolute;
								display: flex;
								flex-direction: column;
								justify-content: center;
								align-items: center;

								span {
									font-size: 14px;
								}

								p {
									font-size: 22px;
									line-height: 22px;
								}
							}
						}
					}

				}

				.tabs {
					position: absolute;
					right: 28px;
					top: 20px;
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					align-items: stretch;
					width: 138px;
					height: 34px;

					div {
						flex: 1;
						border: 1px solid #245898;
						margin-right: -1px;
						display: flex;
						justify-content: center;
						align-items: center;
						font-size: 16px;
						line-height: 100%;
						color: #b7bcc4;
						cursor: pointer;
						transition: all .2s;
						background: linear-gradient(to right, transparent 0%, transparent 50%, transparent 100%);

						&:hover {
							color: #FFF;
						}

						&.on {
							background: linear-gradient(to right, #1e4578 0%, transparent 50%, #1e4578 100%);
							color: #FFF;
						}
					}
				}


			}
		}
	}
	.yqyy{
		max-height: 90vh;
	}
	
	.clamp_1 {
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 1;
		display: -webkit-box !important;
		-webkit-box-orient: vertical;
		word-break:break-all
	}
	
</style>